import React, {Component} from 'react'
import ReactSelect from 'react-select'
import {Field} from 'formik';
import PropTypes from 'prop-types';

export default class Select extends Component
{

	static propTypes = {
		name: PropTypes.string.isRequired,
		options: PropTypes.array.isRequired,
		placeholder: PropTypes.string
	};

	render() {
		return (
			<Field name={this.props.name} className="form-control">
				{({ field, form }) => (
					<ReactSelect
						options={this.props.options}
						name={field.name}
						value={this.props.options ? this.props.options.find(option => option.value === field.value) : ''}
						onChange={(option) => form.setFieldValue(field.name, option.value)}
						placeholder={this.props.placeholder}
					/>
				)}
			</Field>
		);
	};
}


// WEBPACK FOOTER //
// ./React/src/components/form/Select.js